import { render } from "./EnNavigationArea.vue?vue&type=template&id=782b8491&ts=true"
import script from "./EnNavigationArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnNavigationArea.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/navigation/EnNavigationArea/EnNavigationArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "782b8491"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('782b8491', __exports__)) {
    api.reload('782b8491', __exports__)
  }
  
  module.hot.accept("./EnNavigationArea.vue?vue&type=template&id=782b8491&ts=true", () => {
    api.rerender('782b8491', render)
  })

}


export default __exports__